//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { AuditService } from '../system/audit/audit-service';
import { DecryptAesClientSide } from '../../../encryption';
import { environment } from 'src/environments/environment';
import { ErrorStrings, Prefixes, StorageValues, ToastShowDelay } from '../../../consts';
import { Injectable, Injector } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SystemUserDTO } from '../../../models/system/user/system-user.dto';
import { ToastService } from '../../toast-service';

@Injectable({ providedIn: 'root' })

export class ExceptionsService {

  private get auditService(): AuditService { if (!this._auditService) this._auditService=this.injector.get(AuditService); return this._auditService; }
    
  private _auditService?             : AuditService;
  private exceptionNotificationSource: Subject<Error>=new Subject<Error>();
  private isLoggingException         : boolean=false;
  
  public readonly exceptionNotification$: Observable<Error>=this.exceptionNotificationSource.asObservable();
  
  constructor(
    private injector    : Injector,
    private toastService: ToastService
  ) { }

  public formatHttpError(error: any): string {
    var index : number;
    var result: any | string = error;
    
    const body=error?.error;

    if (body && typeof body==='object' && typeof body.error==='string') {
      result=typeof body.auditId==='number' ? (body.error+' (audit ID: '+body.auditId+')') : body.error;

    } else if (typeof error === 'string') {
      index = (error as string).indexOf('\r');

      if (index>1)
        result = (error as string).substring(0, index);
      else
        result = error;

    } //else if (typeof result?.message==="string") {
      //result=result.message;
    //}

    if (environment.removeErrorPrefix && typeof result==='string')
      result = result.replace(Prefixes.SystemError, "").trim();

    return result;
  }
  
  public handleException(error: Error) {
    const message=error?.message ?? 'Unexpected error';

    if (message.includes(ErrorStrings.NoError))
      return;

    const demoMode=this.isDemoMode();

    if (!demoMode)
      this.toastService.show(message, { classname: 'bg-danger text-white', delay: ToastShowDelay.Danger });

    if (environment.outputErrorsToConsole) {
      console.log(`Error: ${message}`);

      if (error?.stack)
        console.log(error.stack);
    }

    if (!this.isLoggingException) {
      this.isLoggingException=true;

      try {
        this.auditService.logError(message);
      }
      finally {
        this.isLoggingException=false;
      }
    }

    if (!demoMode)
      this.exceptionNotificationSource.next(error);
  }

  private isDemoMode(): boolean {
    try {
      const rawUser=DecryptAesClientSide(sessionStorage.getItem(StorageValues.encCurrentUser));

      if (!rawUser)
        return false;

      const userId: number=(<SystemUserDTO>JSON.parse(rawUser))?.userId ?? -1;
      const rawMode       =DecryptAesClientSide(localStorage.getItem(`${StorageValues.encDemoMode_}${userId}`));

      return rawMode==='demo';
    }
    catch {
      return false;
    }
  }

  public handleStringException(error: string) {
    try {
      throw new Error(error);
    }
    catch(e) {
      this.handleException(<Error>e);
    }
  }
}
